import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import axios from "axios";
import moment from "moment";
import useTable from "../../useTableR";
import { Dimmer } from "../../spinner";
import { Mensaje } from "../../mensajes2";
import TablaConsultaGeneralDeudas from "./tablaConsultaDeudaGeneral";
const TablaSolicitudSolvencia = (props) => {
  const op = require("../../../modulos/datos");
  const token = localStorage.getItem("jwtToken");
  const espiritu = localStorage.getItem("espiritu");
  const anioActual = new Date().getFullYear();
  const anios = Array.from(new Array(7), (val, index) => anioActual - index);
  const [datosTabla, setDatosTabla] = useState([]);
  const [anioSeleccionado, setAnioSeleccionado] = useState(anioActual);
  const [loading, setLoading] = useState(false);
  const [seleccionarFiltro, setSeleccionarFiltro] = useState("pendientes");
  const [mostrarDeudas, setMostrarDeudas] = useState(false);
  const [idContribuyente, setIdContribuyente] = useState();
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const filtroBusquea = [
    {
      id: "pendientes",
      label: "Pendientes Pago Registrado",
    },
    {
      id: "aprobadasImp",
      label: "Aprobadas Impresas",
    },
    {
      id: "aprobadasEnt",
      label: "Aprobadas por Entregar",
    },
    { id: "entregadas", label: "Entregadas" },
    {
      id: "todas",
      label: "Todas",
    },
  ];
  const headCells = [
    {
      id: 1,
      label: "N°",
      width: "auto",
      textAlign: "right",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: 2,
      label: "N° RITM",
      width: "auto",
      textAlign: "right",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: 3,
      label: "Nombre",
      width: "auto",
      textAlign: "left",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: 4,
      label: "Rif/Cedula",
      width: "auto",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: 5,
      label: "Direccion",
      width: "auto",
      textAlign: "left",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: 6,
      label: "Fecha",
      width: "auto",
      textAlign: "left",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: 7,
      label: "Status",
      width: "auto",
      textAlign: "left",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: 8,
      label: "Opciones",
      width: "auto",
      textAlign: "left",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
  ];
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(datosTabla, headCells, filterFn);

  const buscarDetalles = async () => {
    setLoading(true);
    let condicion = `estatussolvencia = 1 and estatusnotificacion = 0`;
    if (seleccionarFiltro === "aprobadasImp") {
      condicion = "estatussolvencia = 2";
    } else if (seleccionarFiltro === "aprobadasEnt") {
      condicion =
        "estatussolvencia = 3 or (estatussolvencia = 1 and estatusnotificacion = 1 and usuarioentrega = 0 and usuarioaprueba != 0)";
    } else if (seleccionarFiltro === "entregadas") {
      condicion = `estatussolvencia = 4 or (estatussolvencia = 1 and estatusnotificacion = 1 and usuarioentrega != 0)`;
    } else if (seleccionarFiltro === "todas") {
      condicion = `estatussolvencia >= 0`;
    } else {
      condicion = `estatussolvencia = 1 and estatusnotificacion = 0`;
    }
    condicion += ` and fechasolicitud between '${anioSeleccionado}-01-01' and '${anioSeleccionado}-12-31' `;
    const campos = `
      CASE 
        WHEN estatussolvencia = 0 THEN 'PENDIENTE'
        WHEN estatussolvencia = 1 THEN 'PAGO REGISTRADO'
        WHEN estatussolvencia = 2 THEN 'IMPRESA POR FIRMA'
        WHEN estatussolvencia = 3 
          OR (estatussolvencia = 1 AND estatusnotificacion = 1 AND usuarioentrega = 0 AND usuarioaprueba != 0) 
          THEN 'POR RETIRAR'
        WHEN estatussolvencia = 4 
          OR (estatussolvencia = 1 AND estatusnotificacion = 1 AND usuarioentrega != 0) 
          THEN 'ENTREGADA'
        WHEN estatussolvencia = 5 THEN 'RECHAZADA'
        ELSE NULL
      END AS status,
      COALESCE(c.nombre, v.propietario) AS nombre,
      COALESCE(c.rif, v.cedulapropie) AS cedularif,
      COALESCE(c.direccion, v.direccion) AS direccion,
      s.idsolvencia, 
      s.idcontribuyente,
      s.fechasolicitud as fechaemision,
      estatussolvencia,
      tablacontribuyente, 
      quienexige
      `;
    const tabla = `
      solvenciamunicipal s 
      left join comercio c on c.idcomercio = s.idcontribuyente and tablacontribuyente = 'comercio'
      left join vinmuebles v on v.idinmueble = s.idcontribuyente and tablacontribuyente = 'inmueble'
      `;
    const orden = "idsolvencia";
    const endpoint = `${op.conexion}/api/consulta/selecionarregistrocondi?campos=${campos}&nomtab=${tabla}&condi=${condicion}&orden=${orden}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.status === 200 && response.data.length > 0) {
          const { data } = response;
          setDatosTabla(data);
        } else {
          
          setDatosTabla([]);
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: "Error al Buscar los Detalles",
          icono: "error",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const procesarSolvencia = (id) => {
    try {
      setIdContribuyente(id);
      setMostrarDeudas(true);
    } catch (error) {
      setMensaje({
        mostrar: true,
        titulo: "Error",
        texto: "Error al Procesar la Solvencia",
        icono: "error",
      });
    }
  };
  // const imprimir = () => {
  //   try {
  //     window.open(
  //       op.reportes +
  //         "/actividadeconomica?" +
  //         "reporte=PlanillaAcarigua" +
  //         "&VERIFICADOR=" +
  //         "" +
  //         "&CEDULA=" +
  //         registroSelect.cedularif +
  //         "&ID=" +
  //         registroSelect.idsolvencia +
  //         "&FACTURA=",
  //       +`V${registroSelect.idsolvencia}` + "Planilla",
  //       "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
  //     );
  //   } catch (error) {
  //     setMensaje({
  //       mostrar: true,
  //       titulo: "ERROR",
  //       texto: "Error al Generar el Reporte de Solvencias",
  //       icono: "error",
  //     });
  //   }
  // };

  const cerrar = () => {
    blanquear();
    props.show();
  };
  const blanquear = () => {
    setDatosTabla([]);
    setAnioSeleccionado(anioActual);
    setLoading(false);
    setSeleccionarFiltro("pendientes");
  };
  useEffect(() => {
    buscarDetalles();
  }, [seleccionarFiltro, anioSeleccionado]);
  return (
    <div
      className="col-11 p-1 mx-2 py-0 text-uppercase border-table"
      style={{
        maxHeight: "99vh",
        marginTop: "5%",
      }}
    >
      <header className="col-12 azulGradiant py-2 d-flex align-items-center justify-content-between text-light border-bottom">
        <h3 className="fw-bold text-light m-0">Solicitud de Solvencias</h3>
        <button onClick={() => cerrar()} className="btn btn-sm bg-light">
          <i className="fa fa-times"></i>
        </button>
      </header>
      <div className="d-flex justify-content-between">
        <div className="col-md-3 mr-auto row my-1 py-1">
          <div className="input-group input-group-sm col-md-12 p-0 m-0 mb-0">
            <span
              className="input-group-text text-uppercase"
              id="inputGroup-sizing-sm"
            >
              Buscar por:
            </span>
            <select
              type="text"
              className="form-control text-uppercase"
              aria-label="Sizing example input"
              aria-describedby="inputGroup-sizing-sm"
              value={seleccionarFiltro}
              onChange={(e) => {
                setSeleccionarFiltro(e.target.value);
              }}
            >
              {filtroBusquea.map((e, index) => (
                <option key={index} value={e.id}>
                  {e.label}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className="col-md-2 ml-auto row my-1 py-1">
          <div className="input-group input-group-sm col-md-10 p-0 m-0 mb-0">
            <span
              className="input-group-text text-uppercase"
              id="inputGroup-sizing-sm"
            >
              Año
            </span>
            <select
              type="text"
              className="form-control text-uppercase"
              aria-label="Sizing example input"
              aria-describedby="inputGroup-sizing-sm"
              value={anioSeleccionado}
              onChange={(e) => setAnioSeleccionado(e.target.value)}
            >
              {anios.map((e, index) => (
                <option key={index} value={e}>
                  {e}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>
      <div className="col-12 m-0 p-0">
        <div style={{ maxHeight: "500px", overflowY: "auto" }}>
          <TblContainer>
            <TblHead />
            <tbody>
              {datosTabla && datosTabla.length > 0 ? (
                recordsAfterPagingAndSorting().map((item, index) => (
                  <tr
                    key={index}
                    style={{
                      padding: "0",
                      cursor: "pointer",
                    }}
                  >
                    <td
                      className="align-baseline"
                      style={{
                        fontSize: "10px",
                        textAlign: "right",
                        width: "auto",
                      }}
                    >
                      {item.idsolvencia}
                    </td>
                    <td
                      className="align-baseline"
                      style={{
                        fontSize: "10px",
                        textAlign: "right",
                        width: "auto",
                      }}
                    >
                      {item.idsolvencia}
                    </td>
                    <td
                      className="align-baseline"
                      style={{
                        fontSize: "10px",
                        textAlign: "left",
                        width: "auto",
                      }}
                    >
                      {item.nombre}
                    </td>
                    <td
                      className="align-baseline"
                      style={{
                        fontSize: "10px",
                        textAlign: "center",
                        width: "auto",
                      }}
                    >
                      {item.cedularif}
                    </td>
                    <td
                      className="align-baseline"
                      style={{
                        fontSize: "10px",
                        textAlign: "left",
                        width: "auto",
                      }}
                    >
                      {item.direccion}
                    </td>
                    <td
                      className="align-baseline"
                      style={{
                        fontSize: "10px",
                        textAlign: "left",
                        width: "auto",
                      }}
                    >
                      {item.fechaemision
                        ? moment.utc(item.fechaemision).format("DD-MM-YYYY")
                        : "N/A"}
                    </td>
                    <td
                      className="align-baseline"
                      style={{
                        fontSize: "10px",
                        textAlign: "left",
                        width: "auto",
                      }}
                    >
                      {item.status}
                    </td>
                    <td>
                      <button
                        onClick={() => procesarSolvencia(item.idcontribuyente)}
                        type="button"
                        className="fw-bold btn btn-warning btn-sm rounded-pill mx-1"
                      >
                        <i className="fas fa-share-square" />
                      </button>
                      {/* <button
                        type="button"
                        className="fw-bold btn btn-info btn-sm rounded-pill mx-1"
                      >
                        <i className="fas fa-eye" />
                      </button> */}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan={8}
                    style={{
                      textAlign: "center",
                      padding: "20px",
                      fontSize: "12px",
                      color: "#666",
                    }}
                  >
                    No hay registros disponibles
                  </td>
                </tr>
              )}
            </tbody>
          </TblContainer>
        </div>
        <TblPagination />
      </div>
      <Mensaje
        mensaje={mensaje}
        onHide={() =>
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
      />
      <Dimmer active={loading} inverted />
      <Modal show={mostrarDeudas} size="xl" centered contentClassName="p-0 m-0">
        <Modal.Body>
          <TablaConsultaGeneralDeudas
            modal={true}
            solvencia={true}
            codigo={idContribuyente}
            show={() => setMostrarDeudas(false)}
          />
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default TablaSolicitudSolvencia;
